import { createFileRoute } from "@tanstack/react-router";
import { ControlChartCollectionPage } from "src/components/views/spc/controlChartCollections/ControlChartCollectionPage.tsx";
import { ControlChartCollectionApi } from "src/api/generated/spc/controlChartCollections/controlChartCollectionApi.ts";
import { useKeptAliveGeneratedView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/spc/controlChartCollections/view/$collectionId")({
	staticData: {
		legacyViewKey: "controlChartCollectionPages",
		listGeneratedViews: async () =>
			(await ControlChartCollectionApi.getPermittedCollections()).map((collection) => ({
				id: collection.controlChartCollectionId,
				title: collection.name,
			})),
	},
	component: RouteComponent,
});

function RouteComponent() {
	const {
		view: { generatedId: id },
		isActive,
	} = useKeptAliveGeneratedView();
	return <ControlChartCollectionPage collectionId={id} isActive={isActive} />;
}
